import request from "@/sheep/request";

const HomeApi = {
  // 获取bannar 列表
  getBannerList(data) {
    return request({
      url: "promotion/banner/list",
      method: "GET",
      data,
    });
  },
  // 领取优惠券弹框
  getCouponLogin(data) {
    return request({
      url: "promotion/coupon/login-take",
      method: "GET",
      data,
    });
  },
  // 搜索附件地址信息
  getMemberAddressList(params) {
    return request({
      url: "member/address/search/page",
      method: "GET",
      params,
    });
  },
  // 是否拥有指定栏目权限根据卡券
  getContainType(params) {
    return request({
      url: "pay/recharge-equity/containType",
      method: "GET",
      params,
    });
  },

  // 是否拥有指定栏目权限根据编码
  getContainTypeByCode(params) {
    return request({
      url: "pay/recharge-equity/containTypeCode",
      method: "GET",
      params,
    });
  },
  // 是否显示电影频道点餐入库
  getCardDetail(params) {
    return request({
      url: "pay/coupons-user/isShowMovieDiancan",
      method: "GET",
      params,
    });
  },
  // 是否拥有指定栏目权限根据用户
  getUserType(params) {
    return request({
      url: "pay/recharge-equity/containType",
      method: "GET",
      params,
    });
  },
  // 
  phoneRechargeCheck(data) {
    return request({
      url: "trade/order/phoneRechargeCheck",
      method: "POST",
      data: data,
    });
  },
  // 根据栏目查商品列表
  getSpuList(data) {
    return request({
      url: "product/spu/page-by-type",
      method: "GET",
      data: data,
    });
  },
    // 话费跟新已读
    updateHuafeiMember(data) {
      return request({
        url: "member/user/update-pop-up",
        method: "GET",
        data: data,
      });
    },
    // 获取读了没
    getHuafeiMember(data) {
      return request({
        url: "member/user/get",
        method: "GET",
        data: data,
      });
    },
  // 根据专区获得商品 SPU 分页
  getSpuListByZone(data) {
    return request({
      url: "product/spu/page-by-activityId",
      method: "GET",
      data: data,
    });
  },
  // 根据栏目数组查商品列表
  getSpusList(data) {
    return request({
      url: "product/spu/page-by-type-list",
      method: "POST",
      data: data,
    });
  },
   // 获取领取优惠券
   getCouponById(params) {
    return request({
      url: "promotion/coupon-template/get",
      method: "GET",
      params:params
    });
  },
  // 校验券能不能领
  getCouponCheckTake(params) {
    return request({
      url: "promotion/coupon-template/check_template_take_count",
      method: "GET",
      params:params
    });
  },
  // 校验券能不能领2
  getCouponCheckTake2(params) {
    return request({
      url: "/promotion/coupon/check-exchange",
      method: "GET",
      params:params
    });
  },
  // 领取优惠券
  getExchange: (params) => {
    return request({
      url: '/promotion/coupon/exchange',
      method: 'GET',
      params,
    });
  },
  // 领取优惠券
  CouponCheckTake(params) {
    return request({
      url: "promotion/coupon/take-by-Template-share",
      method: "GET",
      params:params
    });
  },
   // 领取权益卡
   WelfareCheckTake(data) {
    return request({
      url: "promotion/welfare-card/take-by-link",
      method: "POST",
      data:data
    });
  },
   // 领取权益卡
  WelfareThreeCheckTake(data) {
    return request({
      url: "promotion/welfare-card/take-three-welfare-card",
      method: "POST",
      data:data
    });
  },
  // 获取装修页面信息
  getHomeMessage(data) {
    return request({
      url: "promotion/diy-page/get",
      method: "GET",
      data:data
    });
  },
  // 获取点餐品牌列表
  getRedeemBrand(params) {
    return request({
      url: "/product/brand/get-user-diancan-brand",
      method: "GET",
      params,
    });
  },
    // 是否有点餐权益
    getHasDiancanEquity(params) {
      return request({
        url: "/promotion/welfare-card/hasDiancanEquity",
        method: "GET",
        params,
      });
    },
  // 据关键词搜索权益卡
  searchWelfareKeyword(params) {
    return request({
      url: "/promotion/welfare-card/search-keyword",
      method: "GET",
      params,
    });
  },
  // 领取关键词权益卡
  receiveWelfareKeyword(data) {
    return request({
      url: "/promotion/welfare-card/search-keyword-receive",
      method: "POST",
      data:data,
    });
  },
  // promotion'welfare-card/search-keyword-receive
  // 获取电影城市列表
  getCityList() {
    return request({
      url: "movie/city/list",
      method: "GET",
    });
  },
  // 获取电影城市列表
  getNewCityList(params) {
    return request({
      url: "system/area/listCity",
      method: "GET",
      params
    });
  },
  // 获取栏目
  getTypeList(data) {
    return request({
      url: "product/type/getTypeList",
      method: "GET",
      data,
    });
  },
  //转发get 请求
  getProxyUrl(data) {
    return request({
      url: "system/proxy/get",
      method: "GET",
      data,
    });
  },

  //  根据用户绑定卡券获取栏目 /trade/homepage/typeList
  getActiveType(params) {
    return request({
      url: "product/type/getTypeList",
      method: "GET",
      params
    });
  },
  getTypeCoupon(params) {
    return request({
      url: "/promotion/coupon/type-best-coupon",
      method: "GET",
      params
    });
  },
  //  获取默认地址
  getMrAddress(params) {
    return request({
      url: "member/address/get-default",
      method: "GET",
      params
    })
  },
  // 根据用户绑定卡券获取生日汇是否先试试福乐兑
  getPayRedeem(params) {
    return request({
      url: "pay/coupons-user/redeem",
      method: "GET",
      params
    });
  },
  //  根据活动id  获取活动详情 
  getActiveInfo(params) {
    return request({
      url: "pay/card-activity/get-activity",
      method: "GET",
      params
    });
  },

  //  获取升级信息
  getUnreadList(params) {
    return request({
      url: "system/notify-message/get-unread-list",
      method: "GET",
      params
    });
  },

  // 校验分享是否有效
  checkShare(params) {
    return request({
      url: "promotion/invite/check-invite-share",
      method: "GET",
      params
    });
  },

  // 获取活动详情-专区
  getActiveInfo2() {
    return request({
      url: "pay/card-activity/get-url-activity",
      method: "GET",
    })
  },

  // 获取用户自定义的导航入口
  getCustomNav() {
    return request({
      url: "product/type-user/get",
      method: "GET",
    });
  },

  // 更新用户自定义导航
  updateCustomNav(data) {
    return request({
      url: "product/type-user/save",
      method: "PUT",
      data,
    });
  },

  //  根据活动id 获取用户是否还有可消费的卡
  getIsCardCanUse(params) {
    return request({
      url: "pay/coupons-user/isCardCanUseInActivity",
      method: "GET",
      params
    });
  },

  // 获得活动的tap栏目
  getActivityTapList() {
    return request({
      url: "product/type/getTypeListByActivity",
      method: "GET",
    })
  },

  // 获取用户是否有该专区的卡
  getIsCardInActivity() {
    return request({
      url: "pay/coupons-user/isCardInActivity",
      method: "GET",
    })
  },

  // 获得当前秒杀活动
  getActivityNow(params) {
    return request({
      url: "promotion/seckill-activity/get-now",
      method: "GET",
      params
    });
  },
  // 获取秒杀时间段 
  getSeckillTime(params) {
    return request({
      url: "promotion/seckill-config/list",
      method: "GET",
      params
    });
  },

  // 获取秒杀分页 
  getSeckillList(params) {
    return request({
      url: "promotion/seckill-activity/page",
      method: "GET",
      params
    });
  },

  // 获取秒杀活动详情 
  getSeckillDetail(params) {
    return request({
      url: "promotion/seckill-activity/get-detail",
      method: "GET",
      params
    });
  },
  // 效验秒杀商品是否可以购买
  getSeckillCheck(params) {
    return request({
      url: "promotion/seckill-activity/check",
      method: "GET",
      params
    });
  },

  // 获取会员全部充值权益 
  getRechargeAll(params) {
    return request({
      url: "pay/recharge-equity/get/all",
      method: "GET",
      params
    });
  },

  // 新客领取详情
  getTakeDetail(params) {
    return request({
      url: "promotion/coupon/promotion-take-detail",
      method: "GET",
      params
    });
  },
  // 新客领取
  toTake(params) {
    return request({
      url: "promotion/coupon/promotion-take",
      method: "GET",
      params
    });
  },
  // 新客分享
  toShare(params) {
    return request({
      url: "promotion/coupon/promotion-share",
      method: "GET",
      params
    });
  },
    // 新客分享
    generateInviteCode(params) {
      return request({
        url: "promotion/lottery-activity/generate-invite-code",
        method: "GET",
        params
      });
    },
  // 使用锦鲤券
  lotteryActivity(params) {
    return request({
      url: "promotion/lottery-activity/use-ticket",
      method: "GET",
      params
    });
  },
   // 获取当前抽奖活动
   getlotteryActivity(params) {
    return request({
      url: "promotion/lottery-activity/get",
      method: "GET",
      params
    });
  },
   // 获取用户锦鲤券和充能数据
  getlotteryActivityTicket(params) {
    return request({
      url: "promotion/lottery-activity/get-ticket",
      method: "GET",
      params
    });
  },
  updateReadStatus(params) {
    return request({
      url: "promotion/coupon/update-read-status",
      method: "GET",
      params
    });
  },
   // 获取抽奖任务
   getActivityTask(params) {
    return request({
      url: "promotion/lottery-activity/get-task",
      method: "GET",
      params
    });
  },
  // 权益卡
  // 获取权益卡模板
  getWelfareCardTemplateList(params) {
    return request({
      url: "promotion/welfare-card-template/list",
      method: "GET",
      params
    });
  },
  getUserWelfareCard(params) {
    return request({
      url: "promotion/welfare-card-template/get-user-template",
      method: "GET",
      params
    });
  },
  // 获得签到记录分页
  signRecordPage(params) {
    return request({
      url: "member/sign-in/record/page",
      method: "GET",
      params
    });
  },
  // 获得个人签到统计
  signRecordSummary(params) {
    return request({
      url: "member/sign-in/record/get-summary",
      method: "GET",
      params
    });
  },

   // 获取权益卡详情
  getWelfareCardTemplateDetail(params) {
    return request({
      url: "promotion/welfare-card-template/get-detail",
      method: "GET",
      params
    });
  },
   //领取优惠券
   takeWelfareCardCoupon(data) {
    return request({
      url: "promotion/welfare-card/receive-gift",
      method: "POST",
      data
    });
  },
  // 创建权益卡订单
  createWelfareCardOrder(data) {
    return request({
      url: "promotion/welfare-card-order/create",
      method: "POST",
      data
    });
  },
  // 升级权益卡
  upWelfareCardOrder(data) {
    return request({
      url: "promotion/welfare-card-order/upgrade",
      method: "POST",
      data
    });
  },
   // 创建权益卡订单
   getWelfareCardRecord(data) {
    return request({
      url: "promotion/welfare-card/record",
      method: "GET",
      data
    });
  },
  // 兑换权益卡
  exchangeWelfareCard(data) {
    return request({
      url: "/promotion/welfare-card/exchange",
      method: "GET",
      data
    });
  },
  getWelfareCardRecentlyOpen(data) {
    return request({
      url: "/promotion/welfare-card/recently-open-welfare-card-record",
      method: "GET",
      data
    });
  },

  // 获取最优权益卡
  getBestWelfareCard(data) {
    return request({
      url: "/promotion/welfare-card/third-best-welfare-card",
      method: "POST",
      data
    });
  },
  // 查询商品最优权益卡
  getGoodBestWelfareCard(data) {
    return request({
      url: "/promotion/welfare-card/good-best-welfare-card",
      method: "POST",
      data
    });
  },
    // 领取邀请锦鲤券
  activityInvite(params) {
    return request({
      url: "promotion/lottery-activity/invite",
      method: "GET",
      params
    });
  },
   // 查询商品最优权益卡
   getUserTypeEquity(params) {
    return request({
      url: "/promotion/welfare-card/get-user-type-equity",
      method: "GET",
      params
    });
  },
    // 领取邀请锦鲤券
    activityInvite(params) {
      return request({
        url: "promotion/lottery-activity/invite",
        method: "GET",
        params
      });
    },
    // 领取权益卡
    oldUserTakeWelfare(params) {
      return request({
        url: "promotion/welfare-card/old-user-take-welfare-card",
        method: "POST",
        params
      });
    },
    // 获取配置信息
    getConfigValueByKey: (key) => {
      return request({
        url: '/infra/config/get-value-by-key',
        method: 'GET',
        params: {
          key
        },
      });
    },
};

export default HomeApi;
